import { buttonClasses } from '@mui/material/Button';
import { typographyClasses } from '@mui/material/Typography';
export const navItemButtonCss = ({ theme, level, orientation, selected }) => ({
    // stronger overrides (specificity)
    [`&.${buttonClasses.root}`]: {
        boxSizing: 'border-box',
        boxShadow: 'unset',
        // align content
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'start',
        position: 'relative',
        textDecoration: 'none',
        color: theme.tokens.FuelColorGray600,
        border: 'unset',
        borderRadius: 'unset',
        cursor: 'pointer',
        [`&.${buttonClasses.focusVisible}`]: {
            zIndex: 99,
            boxShadow: 'var(--menu-item-outline-focus)'
        },
        ...orientation === 'top' && {
            height: theme.tokens.FuelSpacing10,
            paddingLeft: theme.tokens.FuelSpacing3,
            paddingRight: theme.tokens.FuelSpacing3,
            maxWidth: '15rem'
        },
        ...orientation === 'side' && {
            display: 'flex',
            width: 'calc(100% - 7px)',
            borderRadius: theme.tokens.FuelBorderRadiusBase,
            marginLeft: '7px',
            ...level && level > 0 && {
                paddingLeft: `calc(15px + 1.25rem + ${theme.tokens.FuelSpacing3})` // TODO: icon size
            },
            [`& .${typographyClasses.button}`]: {
                maxWidth: '100%',
                whiteSpace: 'nowrap',
                textOverflow: 'ellipsis',
                overflow: 'hidden',
                paddingRight: theme.tokens.FuelSpacing2,
                textAlign: 'left'
            }
        },
        [`& .${buttonClasses.startIcon}`]: {
            ...orientation === 'top' && {
                marginLeft: -theme.tokens.FuelSpacing2,
                marginRight: theme.tokens.FuelSpacing2
            },
            // push caret icon all the way to the right
            ...orientation === 'side' && {
                marginLeft: 0,
                marginRight: theme.tokens.FuelSpacing3
            }
        },
        [`& .${buttonClasses.endIcon}`]: {
            ...orientation === 'top' && {
                marginRight: -theme.tokens.FuelSpacing2,
                marginLeft: theme.tokens.FuelSpacing1
            },
            // push caret icon all the way to the right
            ...orientation === 'side' && {
                marginLeft: 'auto'
            }
        },
        ...selected && {
            color: theme.tokens.FuelColorTextBrandPrimary,
            ...orientation === 'top' && {
                backgroundColor: 'transparent'
            },
            ...orientation === 'side' && {
                backgroundColor: theme.tokens.FuelColorGreen50
            },
            '&::before': {
                backgroundColor: theme.tokens.FuelColorBrandPrimary,
                display: 'block',
                content: '""',
                position: 'absolute',
                zIndex: 1,
                ...orientation === 'top' && {
                    width: '100%',
                    height: '3px',
                    bottom: 0,
                    left: 0,
                    top: 'auto'
                },
                ...orientation === 'side' && {
                    borderRadius: theme.tokens.FuelBorderRadiusFull,
                    left: '-7px',
                    width: '3px',
                    height: '100%'
                }
            }
        }
    }
});
